import React from 'react';
import {
  Box,
  Typography,
} from '@mui/material';

const formatSignedPoint = (value) => {
  const numericValue = Number(value || 0);
  const sign = numericValue > 0 ? '+' : '';
  return `${sign}${numericValue.toLocaleString()}`;
};

function RoomUserDetail({ user }) {
  return (
    <Box
      sx={{
        maxWidth: '720px',
        mx: 'auto',
        mt: 1,
        backgroundColor: '#f9fafb',
        borderRadius: '8px',
        border: '1px solid #ddd',
        boxShadow: '0 1px 2px rgba(0,0,0,0.05)',
        padding: '12px 16px',
        boxSizing: 'border-box',
      }}
    >
      <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 1 }}>
        あなたのルーム内実績
      </Typography>
      <Box
        sx={{
          fontSize: '13px',
          color: '#555',
          display: 'flex',
          flexDirection: 'column',
          gap: '6px',
        }}
      >
        <span>ルームチップ: {user.point}</span>
        <span>参加ラウンド数: {user.rounds_played}</span>
        <span>的中ラウンド数: {user.wins}</span>
        <span>ルーム内収支: {formatSignedPoint(user.balance)}</span>
      </Box>
    </Box>
  );
}

export default RoomUserDetail;
